import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PitchContext } from "../context/PitchContex";
import axios from "axios";

const Team = () => {
  const { slug } = useParams();
  const {
    user,
    token,
    setPending,
    navigate,
    setAlertMessage,
    setIsErr,
    setShowAlert,
    backendURL,
  } = useContext(PitchContext);

  const [team, setTeam] = useState(null);
  const [requestText, setRequestText] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editedTeam, setEditedTeam] = useState({});

  const isOwner = user?.team?._id === team?._id;

  const getTeam = () => {
    setPending(true);
    axios
      .get(`${backendURL}team/get/${slug}`)
      .then((response) => {
        setPending(false);
        if (response.data.success) {
          setTeam(response.data.team);
        } else {
          setAlertMessage(response.data.message);
          setIsErr(true);
          setShowAlert(true);
        }
      })
      .catch((err) => {
        setPending(false);
        setAlertMessage(err.response?.data?.message || "An error occurred");
        setIsErr(true);
        setShowAlert(true);
      });
  };

  const handleUpdateTeam = async () => {
    try {
      setPending(true);

      const formData = new FormData();
      formData.append("userID", user._id);
      formData.append("name", editedTeam.name || "");
      formData.append("city", editedTeam.city || "");
      formData.append("description", editedTeam.description || "");

      if (editedTeam.imageFile) {
        formData.append("image", editedTeam.imageFile); // assuming 'image' is the field name expected by the backend
      }

      const res = await axios.post(
        `${backendURL}team/update/${team._id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.success) {
        setTeam(res.data.updatedTeam);
        setAlertMessage("Takım bilgileri başarıyla güncellendi.");
        setIsErr(false);
        setShowAlert(true);
        setIsEditing(false);
      } else {
        setAlertMessage(res.data.message || "Güncelleme başarısız.");
        setIsErr(true);
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.response?.data?.message || "Bir hata oluştu.");
      setIsErr(true);
      setShowAlert(true);
    } finally {
      setPending(false);
    }
  };

  const handleSubmit = () => {
    setPending(true);
    axios
      .post(`${backendURL}team/send-match-request`, {
        email: team.captain.email,
        invitedFullname: team.name,
        requesterFullname: user.team.name,
        note: requestText,
        phone: user.phone,
      })
      .then((response) => {
        setPending(false);
        if (response.data.success) {
          axios
            .post(`${backendURL}team/update-quantity`, { teamID: team._id })
            .then((res) => {
              if (res.data.success) {
                setRequestText("");
                window.scrollTo(0, 0);
                setAlertMessage(response.data.message);
                setIsErr(false);
                setShowAlert(true);
              } else {
                setAlertMessage(response.data.message);
                setIsErr(true);
                setShowAlert(true);
              }
            })
            .catch((err) => {
              setPending(false);
              setAlertMessage(
                err.response?.data?.message || "An error occurred"
              );
              setIsErr(true);
              setShowAlert(true);
            });
        } else {
          setAlertMessage(response.data.message);
          setIsErr(true);
          setShowAlert(true);
        }
      })
      .catch((err) => {
        setPending(false);
        setAlertMessage(err.response?.data?.message || "An error occurred");
        setIsErr(true);
        setShowAlert(true);
      });
  };

  useEffect(() => {
    console.log(user);
    getTeam();
    window.scrollTo(0, 0);
  }, []);

  if (!team) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-pulse text-gray-500 text-lg">Yükleniyor...</div>
      </div>
    );
  }

  const PlayerItem = ({ image, name }) => (
    <div className="flex flex-col items-center gap-1 min-w-[100px]">
      <div className="w-10 h-10 rounded-full bg-gray-200 overflow-hidden flex-shrink-0">
        <img
          src={image}
          alt={`${name} avatar`}
          className="w-full h-full object-cover"
        />
      </div>
      <span className="text-gray-700">{name}</span>
    </div>
  );

  return (
    <div className="min-h-screen py-12 px-4 bg-gray-50">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-lg overflow-hidden border border-gray-100 transform transition-all duration-300 hover:shadow-xl">
        {/* Header with Team Image */}
        <div className="relative bg-[#4d9041] p-8">
          <div className="absolute inset-0 bg-black opacity-10"></div>
          <div className="relative z-10 flex justify-center items-center">
            <div className="relative">
              <label className="cursor-pointer group relative">
                <img
                  className="h-48 w-48 object-cover rounded-full border-4 border-white shadow-md transition-transform duration-300 group-hover:opacity-80"
                  src={
                    editedTeam.imagePreview ||
                    editedTeam.image ||
                    team.image ||
                    "https://via.placeholder.com/150"
                  }
                  alt={`${team.name || "Takım"}'s profile`}
                />
                {isEditing && (
                  <>
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const preview = URL.createObjectURL(file);
                          setEditedTeam((prev) => ({
                            ...prev,
                            imageFile: file,
                            imagePreview: preview,
                          }));
                        }
                      }}
                    />
                    <div className="absolute bottom-2 right-2 bg-white text-[#4d9041] text-xs px-2 py-1 rounded-full shadow-sm group-hover:opacity-100 opacity-80">
                      Değiştir
                    </div>
                  </>
                )}
              </label>

              {isOwner && !isEditing && (
                <button
                  onClick={() => {
                    setEditedTeam({ ...team });
                    setIsEditing(true);
                  }}
                  className="absolute top-0 right-0 bg-blue-600 text-white text-sm font-semibold px-4 py-2 rounded-full shadow-md hover:bg-blue-700 transition-all cursor-pointer"
                >
                  Düzenle
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Team Details */}
        <div className="p-8">
          {/* Team Info */}
          <div className="text-center mb-6">
            {isEditing ? (
              <input
                type="text"
                value={editedTeam.name}
                onChange={(e) =>
                  setEditedTeam({ ...editedTeam, name: e.target.value })
                }
                className="text-3xl font-bold text-gray-900 bg-transparent border-b-2 border-gray-300 focus:outline-none text-center"
              />
            ) : (
              <h1 className="text-3xl font-bold text-gray-900 tracking-tight truncate">
                {team.name || "İsim Belirtilmemiş"}
              </h1>
            )}
            {isOwner && !isEditing && (
              <p className="text-sm text-gray-500 mt-1">(Senin Takımın)</p>
            )}
            <div className="mt-3">
              {isEditing ? (
                <input
                  value={editedTeam.city}
                  onChange={(e) =>
                    setEditedTeam({ ...editedTeam, city: e.target.value })
                  }
                  className="bg-white text-[#4d9041] px-4 py-1 rounded-full shadow-sm text-sm font-medium focus:outline-none"
                  placeholder="Şehir"
                />
              ) : (
                <span className="inline-block px- py-1 bg-[#4d9041]/10 text-[#4d9041] text-sm font-medium uppercase tracking-wider rounded-full shadow-sm transition-colors duration-200 hover:bg-[#62a556]/20">
                  {team.city || "Şehir Belirtilmemiş"}
                </span>
              )}
            </div>
          </div>

          {/* Team Stats Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2  mb-8 bg-gray-50 p-6 rounded-xl shadow-inner border border-gray-100">
            {[
              ["Şehir", "city"],
              ["Kaptan", "captain.fullname"],
              ["Oyuncular", "players.length"],
            ].map(([label, key]) => (
              <React.Fragment key={key}>
                <div className="flex items-center">
                  <span className="text-gray-600 text-sm font-medium">
                    {label}:
                  </span>
                </div>
                {isEditing && key === "city" ? (
                  <input
                    type="text"
                    value={editedTeam.city || ""}
                    onChange={(e) =>
                      setEditedTeam({ ...editedTeam, city: e.target.value })
                    }
                    className="w-2/3 border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#4d9041]"
                  />
                ) : (
                  <p className="text-gray-900 font-semibold text-sm text-right truncate">
                    {key === "city"
                      ? team.city || "N/A"
                      : key === "captain.fullname"
                      ? team.captain.fullname || "N/A"
                      : team.players.length || "N/A"}
                  </p>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* Team Description */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-700 mb-3">
              Hakkında
            </h2>
            {isEditing ? (
              <textarea
                value={editedTeam.description || ""}
                onChange={(e) =>
                  setEditedTeam({ ...editedTeam, description: e.target.value })
                }
                className="w-full p-4 border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-[#4d9041]"
                rows="4"
              />
            ) : (
              <p className="text-gray-600 leading-relaxed bg-gray-50 p-4 rounded-lg shadow-inner border border-gray-100">
                {team.description || "Bu takım henüz kendini tanıtmadı."}
              </p>
            )}
          </div>

          {/* Save / Cancel Buttons */}
          {isEditing && (
            <div className="flex justify-center gap-4 mb-6">
              <button
                onClick={handleUpdateTeam}
                className="bg-[#4d9041] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#62a556] transition-all cursor-pointer"
              >
                Kaydet
              </button>
              <button
                onClick={() => setIsEditing(false)}
                className="bg-gray-400 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-500 transition-all cursor-pointer"
              >
                İptal
              </button>
            </div>
          )}

          {/* Players List */}
          {!isEditing && (
            <div className="mb-8">
              <h2 className="text-xl font-semibold text-gray-700 mb-3">
                Takım Oyuncuları
              </h2>
              <div className="flex flex-wrap gap-4">
                {team.players.map((player, index) => (
                  <PlayerItem
                    key={index}
                    name={player.fullname}
                    image={player.profileImage}
                  />
                ))}
              </div>
            </div>
          )}

          {/* Request Section */}
          {!isEditing && (
            <div>
              <h2 className="text-xl font-semibold text-gray-700 mb-3">
                İstek Gönder
              </h2>
              <textarea
                value={requestText}
                onChange={(e) => setRequestText(e.target.value)}
                placeholder="Mesajınızı yazın..."
                className="w-full p-4 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#4d9041] focus:border-transparent resize-none shadow-sm transition-all duration-200 hover:shadow-md"
                rows="4"
              />
              {token ? (
                <button
                  onClick={handleSubmit}
                  className="mt-4 w-full bg-[#4d9041] text-white py-3 rounded-xl font-semibold hover:bg-[#62a556] transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-1 cursor-pointer"
                >
                  Gönder
                </button>
              ) : (
                <button
                  onClick={() => navigate("/giris-yap")}
                  className="mt-4 w-full bg-[#4d9041] text-white py-3 rounded-xl font-semibold hover:bg-[#62a556] transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-1 cursor-pointer"
                >
                  İstek atmak için giriş yapın
                </button>
              )}
            </div>
          )}

          {/* Match Count */}
          {!isEditing && (
            <div className="mt-8 text-center border-t border-gray-200 pt-6">
              <p className="text-gray-700 text-lg">
                Bu takıma{" "}
                <span className="font-bold text-[#4d9041]">
                  {team.matchQuantity || 0}
                </span>{" "}
                kere{" "}
                <span className="font-semibold text-gray-800 uppercase bg-gray-100 px-2 py-1 rounded-md">
                  HALISAHABUL
                </span>{" "}
                ile istek atıldı.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Team;
